// extracted by mini-css-extract-plugin
export default {"column":"src-views-common-components-SDSPanel-SDSPanelColumn-SDSPanelColumn__column--vlhIU"};